import styled from 'styled-components';

import { Select } from '@dreryk/react-components';

export const StyledOccupancySelect = styled(Select)`
   width: 250px;
` as typeof Select;
